import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpContextToken
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { CommonFunctions } from 'src/app/shared/common-functions';
const DEFAULT_HTTP_TIMEOUT = 30000;
const TIMEOUT = new HttpContextToken(() => DEFAULT_HTTP_TIMEOUT);
@Injectable()
export class TimeoutApiInterceptor implements HttpInterceptor {
  public options =  {
    timeOutVal: 30000,
    timedOut: true
  }
  constructor(private commonFunction: CommonFunctions,) {}
  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    const context = request.context;
    if (!context.has(TIMEOUT)) {
      const timeout = this.options.timedOut;
      if (timeout === false) return next.handle(request);
      else if (timeout && this.options.timeOutVal !== DEFAULT_HTTP_TIMEOUT) {
        context.set(TIMEOUT, this.options.timeOutVal);
      }
    }
    return next.handle(request).pipe(timeout(context.get(TIMEOUT)),catchError(error => {
      return this.handleResponseError(error, request, next);
    }));
  }
  handleResponseError(error, request?, next?) {
    if(error.message == 'Timeout has occurred')
    this.commonFunction.displaySnackBarMessage("We'll be right back! Looks like something went wrong but we have our best minds working on it.",'failure')
    return throwError(error);
  }
}